import React from "react";
import { ProjectPage } from ".";
import { PrimaryButton } from "../Button";
import { CheckInCard } from "../CheckInCard";
import { CheckInOverdueCallout } from "./CheckInOverdueCallout";
import { viewerCanPostCheckIn } from "./checkInPermissions";

export function CheckIns(props: ProjectPage.State) {
  const showCheckInButton = viewerCanPostCheckIn(props);

  return (
    <div className="p-4 max-w-3xl mx-auto my-6 overflow-auto">
      <div className="flex items-center gap-2 justify-between">
        <div>
          <h2 className="font-bold text-lg">Чек-ины</h2>
          <div className="flex items-center gap-2 text-sm">Ответственные публикуют еженедельные обновления, чтобы фиксировать прогресс и делиться инсайтами.</div>
        </div>

        {showCheckInButton && (
          <PrimaryButton linkTo={props.newCheckInLink} size="xs" testId="check-in-button">Опубликовать чек-ин</PrimaryButton>
        )}
      </div>

      <CheckInOverdueCallout {...props} className="mt-6" />

      <div className="mt-8">
        {props.checkIns.map((checkIn) => (
          <CheckInCard
            key={checkIn.id}
            checkIn={checkIn}
            mentionedPersonLookup={props.richTextHandlers.mentionedPersonLookup}
            type="project"
            formattedTimePreferences={props.formattedTimePreferences}
          />
        ))}
      </div>
    </div>
  );
}
